import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EaccessAuthService } from '../../auth/eaccess-auth.service';
import { ROLE_AUDIT_TRAIL_MONTHLY_STATEMENTS_DISTRIBUTION_READ } from '../../shared/constants';
import { NGXLogger } from 'ngx-logger';
import { map } from 'rxjs';

export const auditTrailMonthlyStatementsDistributionGuard: CanActivateFn = (route, state) => {
  const authService = inject(EaccessAuthService);
  const router = inject(Router);
  const logger = inject(NGXLogger);

  return authService.hasRole$(ROLE_AUDIT_TRAIL_MONTHLY_STATEMENTS_DISTRIBUTION_READ).pipe(
    map((hasRole) => {
      if (hasRole) {
        logger.log(`User has ${ROLE_AUDIT_TRAIL_MONTHLY_STATEMENTS_DISTRIBUTION_READ} role.`);
        return true;
      } else {
        logger.log(
          `User is not in role ${ROLE_AUDIT_TRAIL_MONTHLY_STATEMENTS_DISTRIBUTION_READ}. Redirecting to landing page.`
        );

        const path = state.url.split('?')[0];
        const queryParams = router.parseUrl(state.url.replace(path, '')).queryParams;

        const url = router.parseUrl(`/?origin=${path}`);

        for (const kvp of Object.entries(queryParams)) {
          if (kvp[0] !== 'origin') {
            url.queryParams[kvp[0]] = kvp[1];
          }
        }

        return url;
      }
    })
  );
};
